export default __webpack_public_path__ + "static/media/loginForm.007f03f4.svg";